import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import Autocomplete, { highlightSubstring } from '@afosto/app-components-react/Autocomplete';
import ColoredChip from '@afosto/app-components-react/ColoredChip';
import { profile as profileApi } from '@afosto/iam/api/Profile';

const ORDER_TAGS_PATH = 'afosto.tenant.odr.orders.tags';

const OptionColorDot = styled.div`
  && {
    width: 16px;
    height: 16px;
    margin-top: 3px;
    margin-right: 12px;
    border-radius: 50%;
    background-color: ${props => props.colorCode};
  }
`;

const OrderTagsAutocomplete = ({ onChange, onBlur, name, ...rest }) => {
  const [isFetchingSuggestions, setIsFetchingSuggestions] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const handleFetchProfile = async () => {
      setIsFetchingSuggestions(true);
      try {
        const { data = [] } = await profileApi.getProfile(ORDER_TAGS_PATH);

        const formattedData = data.reduce((acc, tag) => [...acc, { ...tag, value: tag?.code }], []);
        if (isMounted) {
          setSuggestions(formattedData);
        }
      } catch (error) {
        if (isMounted) {
          setSuggestions([]);
        }
      } finally {
        if (isMounted) {
          setIsFetchingSuggestions(false);
        }
      }
    };

    if (isMounted) {
      handleFetchProfile();
    }

    return () => {
      isMounted = false;
    };
  }, []);

  const renderOption = (option, { inputValue = '' } = {}) => {
    let label = option;

    if (typeof option === 'object') {
      // eslint-disable-next-line prefer-destructuring
      label = option?.label;
    }

    return (
      <Box display="flex">
        <OptionColorDot colorCode={option?.color} /> {highlightSubstring(label, inputValue)}
      </Box>
    );
  };

  const renderTags = (values, getTagProps, ChipProps) => (
    <>
      {values.map((value, index) => (
        <ColoredChip
          label={value.label}
          colorCode={value?.color}
          {...getTagProps({ index })}
          {...ChipProps}
        />
      ))}
    </>
  );

  return (
    <Autocomplete
      {...rest}
      name={name}
      options={suggestions}
      loading={isFetchingSuggestions}
      onChange={onChange}
      onBlur={onBlur}
      multiple
      renderOption={renderOption}
      renderTags={renderTags}
    />
  );
};

OrderTagsAutocomplete.defaultProps = {
  ...Autocomplete.defaultProps,
};

OrderTagsAutocomplete.propTypes = {
  ...Autocomplete.propTypes,
};

export default OrderTagsAutocomplete;
